<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2022-04-03 17:39:03
 * @FilePath: \raacfold\src\components\sequence\AlignSequenceView.vue
-->
<template>
    <div class="baimo-scrollbar bm-none" style="overflow-x: hidden !important;" v-loading="loading">
        <!--<el-scrollbar style="height: 300px" class="baimo-scrollbar bm">-->
        <div style="height: 30px; color: #2F363D; background: #F6F8FA; overflow:hidden;white-space:nowrap;">
            <div class="baimo-toolbar">
                <span style="padding: 6px 10px 0px 10px; height: 30px; line-height: 30px">Sequence Viewer</span>
                <i @click="help" style="float: right;font-size: 14px;padding: 5px 5px 0 0px">
                    <span class="bm-toolbar-btn">Help</span>
                </i>
                <el-dropdown class="download-dropdown" style="float: right;font-size: 14px;padding: 5px 5px 0 0px"
                    @command="seq_download">
                    <span class="el-dropdown-link" style="padding: 0px">
                        <span class="bm-toolbar-btn">Download</span>
                        <!-- <i class="el-icon-download bm-btn" style="padding: 0px"></i> -->
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="png">PNG</el-dropdown-item>
                        <!--<el-dropdown-item command="jpg">JPG</el-dropdown-item>-->
                        <el-dropdown-item command="pdf">PDF</el-dropdown-item>
                        <el-dropdown-item command="svg">SVG</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <i @click="refresh" style="float: right;font-size: 14px;padding: 5px 5px 0 0px">
                    <span class="bm-toolbar-btn">Reset</span>
                </i>
                <i @click="focusClick"
                    :style="{float: 'right',fontSize: '14px', margin: '5px 5px 0 0', color: is_focus_color, cursor: 'pointer'}">
                    <span class="bm-toolbar-btn">Focus</span>
                </i>
                <i @click="multi_check"
                    :style="{float: 'right',fontSize: '14px', margin: '5px 5px 0 0', color: multi_check_color, cursor: 'pointer'}">
                    <span class="bm-toolbar-btn">Multiple Region</span>
                </i>
            </div>
        </div>
        <BaimocMenu></BaimocMenu>
        <div id="seq_container" class="baimo-scrollbar bm-container" v-loading="seq_loading"
            :style="{height: height, width: '100%', background: '#FFFFFF',borderTop: '1px solid #ebeef2'} "></div>
        <!--</el-scrollbar>-->
    </div>
</template>

<script>
    import * as d3 from "d3";
    import global_ from "../../components/units/Global";
    import BaimocMenu from "../../components/menu/BaimocMenu";
    import axios from "axios";

    export default {
        name: "StructureView",
        data() {
            return {
                website: global_.website,
                winHeight: window.innerHeight - 30 - 300 + "px",
                winWidth: window.innerWidth - 352 + "px",
                loading: false,
                seq_loading: false,
                menu_show: false,
                pointer: "",
                selected: {
                    start: "",
                    end: "",
                },
                reduce_seq: {
                    Natural: "MRATPLAAPAGSLSRKKRLELDDNLDTERPVQKRARSGPQPRLPPCLLPLSPPTAPDRATAVATASRLGPYVLLEPEEGGRAYQALHCPTGTEYTCKVYPVQEALAVLEPYARLPPHKHVARPTEVLAGTQLLYAFFTRTHGDMHSLVRSRHRIPEPEAAVLFRQMATALAHCHQHGLVLRDLKLCRFVFADRERKKLVLENLEDSCVLTGPDDSLWDKHACPAYVGPEILSSRASYSGKAADVWSLGVALFTMLAGHYPFQDSEPVL",
                    Reduced: "LELLLLLLLLLLLLEEEELELEEELELEELLEEELELLLELELLLLLLLLLLLLLLEELLLLLLLLELLLLLLLELEELLELLELLELLLLLELLLELLLLEELLLLLELLLELLLEEELLELLELLLLLELLLLLLLELELELELLLELEEELLELELLLLLEELLLLLLELEEELLLLEELELLELLLLEEEEEELLLEELEELLLLLLLEELLLEEELLLLLLLLELLLLELLLLLELLELLLLLLLLLLLLLLELLLEELELLL",
                    Query: "MRATPLAAPAGSLSRKKRLELDDNLDTERPVQKRARSGPQPRLPPCLLPLSPPTAPDRATAVATASRLGPYVLLEPEEGGRAYQALHCPTGTEYTCKVYPVQEALAVLEPYARLPPHKHVARPTEVLAGTQLLYAFFTRTHGDMHSLVRSRHRIPEPEAAVLFRQMATALAHCHQHGLVLRDLKLCRFVFADRERKKLVLENLEDSCVLTGPDDSLWDKHACPAYVGPEILSSRASYSGKAADVWSLGVALFTMLAGHYPFQDSEPVL",
                },
                raac_scheme: [],
                raac_color: [],
                current_protein: null,
                align_hits: null,
                align_seq: "",
                align_mid: "",
                naural_seq: "",
                accession: "",
                canvas_height: 0,
                params: {
                    global: {
                        width: "auto",
                        height: 110,
                        padding: [-40, 10, 20, 10],
                        background: "#FFFFFF",
                    },
                    aa: {
                        fontSize: 16,
                        padding: [1, 0, 0, 68],
                        backgroundPadding: [0, 0, 0, 62],
                        backgroundRect: [16, 20],
                        offset: [0, 14],
                        color: "white",
                    },
                    midline: {
                        fontSize: 14,
                        background: "transparent",
                        color: "#718093",
                    },
                    header: {
                        fontSize: 13,
                        fontFamily: "Monospaced Font",
                        backgroundRect: [170, 20],
                        background: "transparent",
                        color: "#718093",
                        padding: [-5, 15, 0, 0],
                    },
                    ruler: {
                        height: 30,
                        strokeWidth: 2,
                        color: "#718093",
                        padding: [0, 0, 0, 0],
                    },
                    scale: {
                        height: 5,
                        fontSize: 14,
                        color: "#718093",
                        offset: [0, 14],
                        interval: 10,
                    },
                    segmentation: {
                        height: 0.5,
                        color: "#a4b0be",
                    },
                    margin: {
                        top: 5,
                    },
                    feature: {
                        height: 20,
                        backgroundWidth: 40,
                        backgroundHeight: 30,
                        padding: [5, 0, 0, 0],
                    },
                    selected: {
                        color: "#f1f2f6",
                    },
                    Domain: {
                        color: "#ee5253",
                    },
                    "Active site": {
                        color: "#f19066",
                    },
                    Helix: {
                        color: "#f5cd79",
                    },
                    Turn: {
                        color: "#0be881",
                    },
                    Strand: {
                        color: "#34e7e4",
                    },
                    "Signal peptide": {
                        color: "#4bcffa",
                    },
                    Chain: {
                        color: "#B53471",
                    },
                    "Antibody binding": {
                        color: "#5758BB",
                    },
                    Variant: {
                        color: "#833471",
                    },
                    Motif: {
                        color: "#833471",
                    },
                    "Metal binding": {
                        color: "#833471",
                    },
                    Site: {
                        color: "#833471",
                    },
                    Region: {
                        color: "#833471",
                    },
                    "Compositional bias": {
                        color: "#833471",
                    },
                    "Topological domain": {
                        color: "#833471",
                    },
                    Transmembrane: {
                        color: "#833471",
                    },
                    "Modified residue": {
                        color: "#833471",
                    },
                    Glycosylation: {
                        color: "#833471",
                    },
                    "Disulfide bond": {
                        color: "#833471",
                    },
                    "Cross-link": {
                        color: "#833471",
                    },
                },
                tooltip: null,
                seq_len: 0,
                feature_map: {},
                feature_names: {},
                selected_height: 0,
                reload: true,
                is_init: true,
                update_features: [],
                multi_sequence: false,
                is_focus: false,
                multi_check_color: "#a4b0be",
                is_focus_color: "#a4b0be",
                feature_num: 0,
            };
        },
        components: {
            BaimocMenu,
        },
        mounted() {
            this.init();
            document.body.scrollLeft = 100;
            window.oncontextmenu=function(e){
    //取消默认的浏览器自带右键 很重要！！
    e.preventDefault();
}
        },
        props: {
            height: String,
            width: String,
        },
        watch: {
            "$store.state.features_data"(val) {
                // console.log('$store.state.features_data', val, oldval);
                this.update_features = val;
                this.reload = false;
                // console.log("$store.state.features_data", val);
                this.main_process();
            },
            "$store.state.raac_color"(val) {
                this.raac_color = val;
                this.reload = false;
                if (!this.is_init) this.main_process();
            },
            "$store.state.raac_scheme"(val) {
                this.raac_scheme = val;
                this.reload = false;
                if (!this.is_init) this.main_process();
            },
            "$store.state.current_protein"(val, val1) {
                this.source_db = val["source_db"]
                this.current_protein = val;
                if(this.source_db === "AlphaFold"){
                    if (val["accession"] !== val1["accession"] || val["pdb_id"] !== val1["pdb_id"] || this.is_init) {
                    // console.log("current_protein", val["accession"]);
                    this.current_protein = val;
                    this.reload = true;
                    this.update_features = [];
                    this.main_process();
                }
                }else{
                    if (val["accession"] !== val1["accession"] || val["pdb_id"] !== val1["pdb_id"] || this.is_init) {
                        // console.log("current_protein", val["accession"]);
                        this.current_protein = val;
                        this.reload = true;
                        this.update_features = [];
                        this.main_process();
                    }
                }
            },
            "$store.state.align_hits"(val) {
                this.align_hits = val;
                this.reload = false;
            },
            "$store.state.sequence_menu"(obj) {
                this.multi_sequence = obj["multi"];
                this.is_focus = obj["focus"];
            },
            multi_sequence() {
                if (this.multi_sequence) this.multi_check_color = "#1e90ff";
                else this.multi_check_color = "#a4b0be";
            },
            is_focus() {
                if (this.is_focus) this.is_focus_color = "#1e90ff";
                else this.is_focus_color = "#a4b0be";
            },
        },
        methods: {
            help() {
                const current = this.$router.resolve({
                    path: "/help"
                });
                window.open(current.href, '_blank');
            },
            multi_check() {
                this.multi_sequence = !this.multi_sequence;
                if (this.multi_sequence) this.multi_check_color = "#1e90ff";
                else this.multi_check_color = "#a4b0be";
                let sequence_menu = this.$store.state.sequence_menu;
                sequence_menu["multi"] = this.multi_sequence;
                this.$store.commit("sequenceMenuMutation", sequence_menu);

                // if (this.multi_sequence) {
                //     this.$message("Enable multiple region mode");
                //     // this.refresh();
                // } else {
                //     this.$message("Enable Single region mode");
                //     // this.refresh();
                // }
            },
            focusClick(){
                this.is_focus = !this.is_focus;
                if (this.is_focus) this.is_focus_color = "#1e90ff";
                else this.is_focus_color = "#a4b0be";
                let sequence_menu = this.$store.state.sequence_menu;
                sequence_menu["focus"] = this.is_focus;
                this.$store.commit("sequenceMenuMutation", sequence_menu);
            },
            init() {
                let sequence_menu = this.$store.state.sequence_menu;
                sequence_menu["multi"] = this.multi_sequence;
                sequence_menu["focus"] = this.is_focus;
                sequence_menu["color"] = [""];
                sequence_menu["representation"] = [""];
                this.$store.commit("sequenceMenuMutation", sequence_menu);
            },
            main_process() {
                if (this.current_protein != null) {
                    // console.log("main_process");
                    this.data_process();
                    this.extract_features();
                    this.is_init = false;
                }
            },
            data_process() {
                if (this.current_protein != null) {
                    this.accession = this.current_protein["accession"];
                    this.get_align_seq();
                    this.reduce_seq["Natural"] =
                        this.current_protein["natural_seq"];
                    this.reduce_seq["Reduced"] = this.get_reduced_seq(
                        this.current_protein["natural_seq"]
                    );
                    this.current_protein["reduced_seq"] =
                        this.reduce_seq["Reduced"];
                    this.reduce_seq["Query"] = this.align_seq;
                }
            },
            render_process() {
                let source_db = this.current_protein['source_db']
                let params = this.params;
                let sequence = this.reduce_seq;
                let natural = sequence["Natural"];
                let reduced = sequence["Reduced"];
                let target = sequence["Query"];
                let seq_len = natural.length;
                this.seq_len = seq_len;
                this.loading = true;
                let feature_num = Object.keys(this.feature_map).length;
                if (this.update_features.length > 0) {
                    feature_num = 0;
                    this.update_features.forEach(function(item) {
                        if (item["visible"]) {
                            feature_num += 1;
                        }
                    });
                }
                // console.log("feature_num", feature_num, Object.keys(this.feature_map))
                document.getElementById("seq_container").innerHTML = "";
                let width =
                    params["header"]["backgroundRect"][0] +
                    seq_len * params["aa"]["backgroundRect"][0] +
                    params["global"]["padding"][1] +
                    params["global"]["padding"][3];
                let height =
                    params["ruler"]["height"] +
                    params["aa"]["backgroundRect"][1] * 7 +
                    params["feature"]["backgroundHeight"] * feature_num +
                    params["global"]["padding"][0] +
                    params["global"]["padding"][2];
                this.selected_height =
                    params["ruler"]["height"] +
                    params["scale"]["height"] +
                    params["header"]["backgroundRect"][1] * 7 +
                    params["feature"]["backgroundHeight"] * feature_num;
                d3.select("#sequence_viewer").remove();
                this.svg = d3
                    .select("#seq_container")
                    .append("svg")
                    .attr("id", "sequence_viewer")
                    .attr("width", width)
                    .attr("height", height)
                    .attr("fill", 'white')
                    .attr(
                        "style",
                        `background-color:${params["global"]["background"]}`
                    )
                    .on("contextmenu", function() {
                        d3.event.preventDefault();
                    });
                // this.svg.attr("fill", 'red')
                var child = this.svg
                    .append("g")
                    .attr("width", width)
                    .attr("height", height)
                    .attr("background", "blue");
                this.seleted_g = child.append("g");
                var zooming = false;
                this.svg.call(
                    d3.behavior
                    .zoom()
                    .translate([0, 0])
                    .scale(1.0)
                    .scaleExtent([0.5, 1.5])
                    .on("zoom", function() {
                        // console.log("zoom", param);
                        if (zooming) {
                            child.attr(
                                "transform",
                                "scale(" + d3.event.scale + ")"
                            );
                            document
                                .getElementById("sequence_viewer")
                                .setAttribute("width", width * d3.event.scale);
                            document
                                .getElementById("sequence_viewer")
                                .setAttribute(
                                    "height",
                                    height * d3.event.scale
                                );
                        }
                    })
                );
                d3.select("body").on("keydown", function() {
                    zooming = d3.event.altKey;
                });

                d3.select("body").on("keyup", function() {
                    zooming = false;
                });
                this.svg = child;
                this.selector_region = this.svg
                    .append("g")
                    .attr("id", "selecter_tag");
                this.cursor = this.svg.append("g").attr("id", "cursor");
                this.bmtooltips();
                // this.add_motif(natural);
                this.add_ruler(natural);
                this.add_header("Reduced", 2);
                this.add_aa(reduced, 2, true);
                this.add_header("Natural", 3);
                this.add_aa(natural, 3, false);
                if(source_db === "AlphaFold") {
                    this.add_header("Confidence", 4);
                    this.add_confidence(natural, 4, false);
                }else{
                    this.add_header("PDB", 4);
                    this.add_pdbseq(this.current_protein['pdb_seq'], 4, false);
                }

                // this.add_header("Confidence", 4);
                // this.add_confidence(natural, 4, false);
                this.add_header("Query", 5);
                this.add_aa(target, 5, false);
                // this.add_header("Conservative", 6);

                this.add_select_layer(natural);
                this.render_features();
                // this.render_domain(params);
                this.loading = false;
            },
            add_pdbseq(seq, num, is_reduce) {
                let params = this.params;
                let start = this.current_protein['pdb_start'];
                // console.log("this.current_protein", this.current_protein)
                // console.log("start", start)
                // console.log("seq", seq)
                let colors = {
                    A: "#f3a683",
                    B: "#8e44ad",
                    C: "#cf6a87",
                    D: "#e77f67",
                    E: "#f5cd79",
                    F: "#ea8685",
                    G: "#546de5",
                    H: "#e15f41",
                    I: "#c44569",
                    K: "#f8a5c2",
                    L: "#786fa6",
                    M: "#63cdda",
                    N: "#778beb",
                    P: "#596275",
                    Q: "#f19066",
                    R: "#f7d794",
                    S: "#574b90",
                    T: "#f78fb3",
                    U: "#34495e",
                    V: "#303952",
                    W: "#3dc1d3",
                    Y: "#e66767",
                    X: "#bdc3c7",
                    a: "#f3a683",
                    b: "#8e44ad",
                    c: "#cf6a87",
                    d: "#e77f67",
                    e: "#f5cd79",
                    f: "#ea8685",
                    g: "#546de5",
                    h: "#e15f41",
                    i: "#c44569",
                    k: "#f8a5c2",
                    l: "#786fa6",
                    m: "#63cdda",
                    n: "#778beb",
                    p: "#596275",
                    q: "#f19066",
                    r: "#f7d794",
                    s: "#574b90",
                    t: "#f78fb3",
                    u: "#34495e",
                    v: "#303952",
                    w: "#3dc1d3",
                    y: "#e66767",
                    x: "#bdc3c7",
                    " ": "transparent",
                    "-": "transparent",
                    "*": "#353b48",
                };
                if (is_reduce) {
                    colors = this.get_raac_color();
                }
                for (let i = 0; i < seq.length; i++) {
                    let aa = seq[i];
                    this.svg
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr("height", params["aa"]["backgroundRect"][1])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] * (start+i)
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["backgroundPadding"][0]
                        )
                        .attr("text-anchor", "middle")
                        .attr("fill", colors[aa]);

                    this.svg
                        .append("text")
                        .text(aa)
                        .attr("fill", params["aa"]["color"])
                        .attr("font-size", params["aa"]["fontSize"])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] / 2 +
                            params["aa"]["fontSize"] * (start+i)
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["padding"][0]
                        )
                        .attr("text-anchor", "middle")
                        // .attr("dominant-baseline","middle")
                        .attr("dx", params["aa"]["offset"][0])
                        .attr("dy", params["aa"]["offset"][1]);
                }
            },
            add_confidence(seq, num) {
                let params = this.params;
                // console.log("this.current_protein['score']", this.current_protein['score'])
                let confidence_strs = this.current_protein['score'];
                let confidence_vals = confidence_strs.split("|");
                let confidence_arr = [];
                confidence_vals.forEach((item) => {
                    confidence_arr.push(parseFloat(item));
                });
                // console.log(confidence_arr);
                var colourScale = d3.scale
                    .linear()
                    .domain([0, 50, 70, 90, 100])
                    // .range([
                    //     "#FFFFFF",
                    //     "#dfe4ea",
                    //     "rgb(101, 203, 243)",
                    //     "#00b894",
                    // ]);
                    // .range(["#FFFFFF", "#dfe4ea", "#00d2d3", "#1dd1a1"]);
                    .range(["#EFF425", "#E4685D", "#B9318A", "#2C0494"]);
                let confidence_color = [];
                for (let i = 0; i < seq.length; i++) {
                    let color = colourScale(confidence_arr[i]);
                    confidence_color.push(color.replace("#", "0x"))
                    this.svg
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr("height", params["aa"]["backgroundRect"][1])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] * i
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["backgroundPadding"][0]
                        )
                        .attr("text-anchor", "middle")
                        .attr("fill", color);
                }
                let structure_global_setting = this.$store.state.structure_global_setting;
                structure_global_setting["confidence"] = {'color': confidence_color, 'value': confidence_arr};
                this.$store.commit("StructureGlobalSettingMutation", structure_global_setting);
                // console.log("this.$store.state.structure_global_setting", this.$store.state.structure_global_setting)
            },
            add_conservative(conservative_val, num) {
                let params = this.params;
                
                // console.log(confidence_arr);
                var colourScale = d3.scale
                    .linear()
                    .domain([0, 1.5, 2.5, 3.5, 4, 4.4])
                    // .range(["#FFFFFF", "#F4F78A", "#FB9007", "#FB9007", "#5F126D", "#280B51"]);
                    .range(["#FFFFFF", "#FCE81E", "#8FD642", "#27AE81", "#32638E", "#430759"]);

                let conservative_color = {};
                for (let key in conservative_val) {
                    let index = key - 1;
                    let score = conservative_val[key];
                    let color = colourScale(score);
                    conservative_color[index] = color.replace("#", "0x");
                    this.svg
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr("height", params["aa"]["backgroundRect"][1])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] * index
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["backgroundPadding"][0]
                        )
                        .attr("text-anchor", "middle")
                        .attr("fill", color);
                }

                // 补充空位置
                let max_key = 0;
                for (let key in conservative_color) {
                    if(key > max_key) max_key = key;
                }

                for (let i = 0; i < max_key; i++) {
                    if (!Object.prototype.hasOwnProperty.call(conservative_color, i)) {
                        conservative_color[i] = "0xFFFFFFFF";
                    }
                }
                let structure_global_setting = this.$store.state.structure_global_setting;
                structure_global_setting["conservative"] = {color:conservative_color};
                this.$store.commit("StructureGlobalSettingMutation", structure_global_setting);
            },
            add_motif() {
                let params = this.params;
                let raac_scheme = this.$store.state.raac_scheme;
                let jobid = this.$route.params.jobid;
                let url = `${this.website}/api/logo_info/${jobid}/${raac_scheme}/`;
                // console.log(url);

                axios.get(url).then((res) => {
                    let logo_data = res.data.results["logo"];
                    let aa = "";
                    let score = 0;
                    let index = 0;
                    let motif_map = {};
                    logo_data.forEach((item) => {
                        aa = item["aa"];
                        score = item["score"];
                        index = item["index"] + 1;
                        if (Object.prototype.hasOwnProperty.call(motif_map, index)) {
                            motif_map[index].push({
                                aa: aa,
                                score: score,
                            });
                        } else {
                            motif_map[index] = [{
                                aa: aa,
                                score: score,
                            }, ];
                        }
                    });

                    this.render_motif(motif_map);
                });

                // Y
                this.svg
                    .append("line")
                    .attr(
                        "x1",
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0]
                    )
                    .attr("y1", params["global"]["padding"][0] - 2)
                    .attr(
                        "x2",
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0]
                    )
                    .attr(
                        "y2",
                        3.2 * params["aa"]["backgroundRect"][0] +
                        params["global"]["padding"][0]
                    )
                    .attr(
                        "style",
                        `stroke:${params["ruler"]["color"]};stroke-width:${params["ruler"]["strokeWidth"]}`
                    );
                this.add_y_scale(params);
            },
            add_y_scale(params) {
                for (let i = 0; i < 5; i++) {
                    let y =
                        params["global"]["padding"][0] +
                        params["header"]["backgroundRect"][1] * 2.5 -
                        i * 12;
                    // let x = params['global']['padding'][3] + params['header']['backgroundRect'][0] + params['aa']['backgroundRect'][0]/2 + params['aa']['backgroundRect'][0]*i;
                    let x =
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0];
                    y;
                    let l_scale = 5;
                    let text_scale = "";
                    if (i % 2 === 0) {
                        l_scale = 10;
                        text_scale = i + "";
                    } else {
                        l_scale = 5;
                        text_scale = "";
                    }
                    this.svg
                        .append("line")
                        .attr("x1", x)
                        .attr("y1", y)
                        .attr("x2", x - l_scale)
                        .attr("y2", y)
                        .attr(
                            "style",
                            `stroke:${params["ruler"]["color"]};stroke-width:${params["ruler"]["strokeWidth"]}`
                        );
                    this.svg
                        .append("text")
                        .text(text_scale)
                        .attr("fill", params["scale"]["color"])
                        .attr("font-size", params["scale"]["fontSize"])
                        .attr("x", x - params["aa"]["backgroundRect"][0] * 1.2)
                        .attr("y", y - params["aa"]["backgroundRect"][1] / 2)
                        .attr("text-anchor", "middle")
                        // .attr("dominant-baseline","middle")
                        .attr("dx", params["scale"]["offset"][0])
                        .attr("dy", params["scale"]["offset"][1]);
                }
            },
            render_motif(motif_map) {
                motif_map;
                let current_accession = this.current_protein["accession"];
                // let motif_start = 0;
                let source_db = this.current_protein['source_db'];
                let pdb_offset = 0;
                if(source_db === "PDB") {
                    pdb_offset = this.current_protein['pdb_start']
                }
                this.align_hits["hits"].forEach((hit) => {
                    let hit_accession =
                        hit["description"][0]["title"].split("|")[1];
                    if (hit_accession === current_accession) {
                        let hsps = hit["hsps"];
                        // let query_len = hit['len'];
                        // align_mid = " ".repeat(query_len);
                        hsps.forEach((hsp) => {
                            let hit_from = hsp["hit_from"] + pdb_offset;
                            let hit_to = hsp["hit_to"];
                            let query_from = hsp["query_from"];
                            // let query_to = hsp['query_to'];
                            let align_len = hsp["align_len"];
                            let hseq = hsp["hseq"];
                            let qseq = hsp["qseq"];
                            let qgap = 0;
                            let hgap = 0;

                            for (let i = 0; i < hit_to - hit_from + 1; i++) {
                                if (qseq[i] === "-") {
                                    qgap += 1;
                                }
                                if (hseq[i] === "-") {
                                    hgap += 1;
                                }
                            }

                            let motif_start = query_from;
                            // let x_start = hit_from - 1 - (query_from - 1);
                            // let motif_max_len = align_len + qgap + hgap + (query_from - 1);
                            let motif_max_len =
                                align_len + qgap + hgap + query_from;
                            let motif_len = hit_to - hit_from + hgap;
                            // console.log('motif_max_len', motif_max_len, 'align_len', align_len, "qgap", qgap, "hgap", hgap, "query_from", query_from-1);

                            let new_motif_map = {};
                            let motif_j = hit_from;
                            let seq_i = 0;
                            let motif_gap = 0;
                            // let data_i in motif_map
                            for (
                                let data_i = motif_start; data_i < motif_max_len; data_i++
                            ) {
                                // console.log("---->", data_i, motif_start+motif_len, data_i <= motif_start+motif_len)
                                if (
                                    hseq[seq_i] !== "-" &&
                                    data_i <= motif_start + motif_len
                                ) {
                                    if (qseq[seq_i] === "-") {
                                        new_motif_map[motif_j] = [{
                                            aa: "",
                                            score: 0
                                        }, ];
                                        // console.log("new_motif_map", seq_i, data_i, motif_j, qseq[seq_i], motif_map[data_i], '-----')
                                        // console.log("new_motif_map", motif_j, qseq[seq_i], new_motif_map[motif_j], motif_map[data_i], '-----')
                                        motif_j += 1;
                                        motif_gap += 1;
                                    } else {
                                        new_motif_map[motif_j] =
                                            motif_map[data_i - motif_gap];
                                        // console.log("new_motif_map", motif_j, motif_gap, qseq[seq_i], new_motif_map[motif_j], motif_map[data_i - motif_gap])
                                        motif_j += 1;
                                    }
                                }
                                seq_i += 1;
                            }

                            let conservative_val = {};
                            for (let index in new_motif_map) {
                                // console.log(new_motif_map[index], index);
                                let vals = new_motif_map[index];
                                let score = 0;
                                vals.forEach((ele) => {
                                    score += ele["score"];
                                });
                                conservative_val[index] = parseFloat(
                                    score.toFixed(2)
                                );
                                this.render_motif_ele(new_motif_map[index], index);
                            }
                            // this.add_conservative(conservative_val, 6);
                            hit_from,
                            hit_to,
                            query_from,
                            hseq,
                            qseq,
                            motif_start,
                            hgap;
                        });
                    }
                });
            },
            render_motif_ele(motif_ele, x_index) {
                let params = this.params;
                let aa_rect_w = 50;
                let aa_rect_h = 55;
                let max_score = 4.2;
                let aa_dict = {
                    A: "M50,55H38.09l-3.84-12.6H15.62L11.85,55H0L18.76,0H31.6L50,55z M31.67,33.34l-5.82-19.07c-0.38-1.21-0.64-2.81-0.79-4.79h-0.3c-0.13,1.61-0.43,3.16-0.89,4.65L18,33.34H31.67z",
                    C: "M50,52.15C45.31,54.05,39.2,55,31.66,55c-9.71,0-17.41-2.4-23.11-7.19C2.85,43.01,0,36.62,0,28.63\n" +
                        "\t\tc0-8.4,3.18-15.27,9.55-20.62C15.91,2.67,24.13,0,34.19,0C40.49,0,45.76,0.68,50,2.03v10.95c-4.35-2.11-9.29-3.16-14.81-3.16\n" +
                        "\t\tc-6.3,0-11.33,1.66-15.1,4.98c-3.77,3.32-5.66,7.66-5.66,13.01c0,5.22,1.79,9.42,5.37,12.6c3.58,3.18,8.42,4.77,14.52,4.77\n" +
                        "\t\tc5.74,0,10.97-1.14,15.68-3.43V52.15z",
                    D: "M0,55V0h19.67C39.89,0,50,8.94,50,26.81c0,8.5-2.83,15.32-8.49,20.47S28.54,55,19.6,55H0z M12.13,9.59v35.83h6.62\n" +
                        "\t\tc5.76,0,10.28-1.66,13.57-4.97c3.28-3.31,4.93-7.8,4.93-13.46c0-5.47-1.72-9.73-5.15-12.8c-3.43-3.07-7.89-4.6-13.38-4.6H12.13z",
                    E: "M50,55H0V0h48.04v9.59H17.99v12.96h27.92v9.55H17.99v13.32H50V55z",
                    F: "M50,9.59H18.69v14.13h28.82v9.59H18.69V55H0V0h50V9.59z",
                    G: "M50,50.5c-5.58,3-12.44,4.5-20.58,4.5c-9.1,0-16.27-2.38-21.53-7.14C2.63,43.1,0,36.59,0,28.32\n" +
                        "\t\tc0-8.38,2.89-15.19,8.68-20.44S22.1,0,31.56,0c6.1,0,11.42,0.8,15.97,2.4v10.75c-4.42-2.4-9.83-3.6-16.22-3.6\n" +
                        "\t\tc-5.51,0-9.97,1.67-13.38,5.01c-3.42,3.34-5.13,7.75-5.13,13.22c0,5.56,1.54,9.9,4.63,13.01c3.09,3.11,7.29,4.67,12.63,4.67\n" +
                        "\t\tc3.17,0,5.76-0.46,7.78-1.37V33.16H26.29v-9.1H50V50.5z",
                    H: "M50,55H37.5V32.31h-25V55H0V0h12.5v22.19h25V0H50V55z",
                    I: "M-0.62,9.18V0H50v9.18H-0.62z M-0.62,55v-9.22H50V55H-0.62z M17.19,55V0h14.88v55H17.19z",
                    K: "M50,55H33.45L14.89,30.96c-0.48-0.62-1.02-1.57-1.62-2.88h-0.2V55H0V0h13.06v25.99h0.2\n" +
                        "\t\tc0.58-1.14,1.16-2.12,1.74-2.95L32.58,0h15.6L26.25,26.24L50,55z",
                    L: "M50,55H0V0h18.15v45.41H50V55z",
                    M: "M40.65,55V21.62c0-3.08,0.12-6.95,0.37-11.61H40.8c-0.57,3.53-1.03,5.88-1.38,7.07L28.47,55h-7.54L9.83,17.43\n" +
                        "\t\tc-0.27-0.9-0.74-3.37-1.4-7.42H8.17c0.25,4.62,0.37,9.24,0.37,13.88V55H0V0h13.76l9.58,33.23c0.8,2.75,1.35,5.33,1.63,7.74h0.2\n" +
                        "\t\tc0.59-3.01,1.2-5.61,1.83-7.81L36.61,0H50v55H40.65z",
                    N: "M50,55H37.73L13.91,19.42c-1.23-1.85-2.13-3.34-2.69-4.47h-0.18c0.22,1.89,0.33,4.82,0.33,8.77V55H0V0h13.07\n" +
                        "\t\tl22.95,34.58c1.53,2.3,2.46,3.75,2.8,4.37H39c-0.24-1.33-0.36-3.86-0.36-7.6V0H50V55z",
                    P: "M14.85,35.83V55H0V0h23.99C41.33,0,50,5.8,50,17.4c0,5.63-2.62,10.15-7.85,13.55\n" +
                        "\t\tc-5.24,3.4-11.78,5.02-19.64,4.88H14.85z M14.85,9.09v17.75h6.44c8.73,0,13.1-2.99,13.1-8.98c0-5.85-4.32-8.77-12.96-8.77H14.85z",
                    Q: "M0,25.31c0-7.48,2.12-13.57,6.37-18.27C10.62,2.35,16.23,0,23.2,0c6.63,0,11.98,2.27,16.02,6.81\n" +
                        "\t\tc4.05,4.54,6.07,10.38,6.07,17.51c0,7.44-2.11,13.48-6.32,18.13c-0.26,0.29-0.52,0.57-0.78,0.83L50,55H35.34l-6.18-6.47\n" +
                        "\t\tc-2.08,0.58-4.32,0.86-6.71,0.86c-6.65,0-12.06-2.25-16.22-6.74C2.08,38.16,0,32.38,0,25.31z M10.4,24.76\n" +
                        "\t\tc0,4.64,1.09,8.44,3.27,11.39c2.18,2.95,5.17,4.42,8.96,4.42c3.88,0,6.89-1.41,9.05-4.24c2.16-2.83,3.24-6.62,3.24-11.39\n" +
                        "\t\tc0-4.97-1.05-8.9-3.15-11.79c-2.1-2.89-5.06-4.33-8.87-4.33c-3.88,0-6.93,1.48-9.16,4.44S10.4,20.05,10.4,24.76z",
                    R: "M50,55H35.13l-9.51-14.31c-1.96-2.96-3.56-4.86-4.81-5.72c-1.25-0.85-2.58-1.28-3.99-1.28h-3.91V55H0V0h21.24\n" +
                        "\t\tc14.42,0,21.64,4.97,21.64,14.91c0,3.74-1.21,6.95-3.62,9.62c-2.41,2.68-5.73,4.56-9.96,5.65v0.14c2.79,0.85,5.88,3.65,9.27,8.38\n" +
                        "\t\tL50,55z M12.91,8.91v15.84h6.34c3.03,0,5.46-0.8,7.3-2.4c1.84-1.6,2.76-3.59,2.76-5.98c0-4.97-3.27-7.46-9.82-7.46H12.91z",
                    S: "M0.29,40.68C6.23,44.23,12.98,46,20.54,46c4.29,0,7.52-0.53,9.68-1.6c2.16-1.06,3.24-2.43,3.24-4.1\n" +
                        "\t\tc0-1.44-0.86-2.8-2.57-4.09C29.17,34.94,24.64,33.2,17.3,31C5.77,27.48,0,22.35,0,15.62C0,10.68,2.61,6.84,7.84,4.1\n" +
                        "\t\tC13.07,1.37,19.99,0,28.6,0c7.21,0,13.27,0.68,18.16,2.03v10.64C41.8,10.24,36,9.03,29.36,9.03c-3.88,0-6.97,0.51-9.29,1.53\n" +
                        "\t\tc-2.32,1.02-3.48,2.39-3.48,4.1c0,1.37,0.79,2.64,2.38,3.79c1.59,1.16,5.51,2.72,11.77,4.69c7.34,2.27,12.38,4.66,15.13,7.17\n" +
                        "\t\tc2.75,2.52,4.12,5.52,4.12,9c0,5.1-2.51,9-7.53,11.67S30.31,55,21.07,55c-8.45,0-15.38-0.98-20.78-2.95V40.68z",
                    T: "M50,9.59H31.8V55H18.16V9.59H0V0h50V9.59z",
                    V: "M50,0L31.35,55H18.41L0,0h12.34l11.62,38.88c0.58,1.92,0.94,3.73,1.07,5.43h0.21\n" +
                        "\t\tc0.18-1.75,0.58-3.61,1.18-5.57L38.04,0H50z",
                    W: "M50,0l-9.54,55h-8.48l-6.1-35.86c-0.32-1.94-0.52-3.96-0.58-6.07h-0.09c-0.15,2.46-0.37,4.49-0.65,6.07\n" +
                        "\t\tL18.34,55h-8.8L0,0h8.36l5.31,37.28c0.23,1.63,0.39,3.69,0.48,6.18h0.16c0.08-1.94,0.32-4.06,0.72-6.36L21.69,0h8.11l6.05,37.57\n" +
                        "\t\tc0.25,1.49,0.44,3.43,0.58,5.82h0.12c0.06-2.06,0.24-4.07,0.53-6.04L42.26,0H50z",
                    Y: "M50,0L30.95,35.36V55H18.52V35.58L0,0h14.19l9.79,21.02c0.2,0.43,0.67,1.87,1.39,4.33h0.15c0.3-1.66,0.72-3.07,1.24-4.23\n" +
                        "\t\tL36.82,0H50z",
                };
                let scale_y = 0;
                let y = params["global"]["padding"][0];
                let x_axis_len = params["aa"]["backgroundRect"][0];
                let y_axis_len = 3.2 * params["aa"]["backgroundRect"][0] - 2;
                // console.log(x_axis_len);
                let scale_x = x_axis_len / aa_rect_w;
                let colors = {
                    A: "#f3a683",
                    B: "#8e44ad",
                    C: "#cf6a87",
                    D: "#e77f67",
                    E: "#f5cd79",
                    F: "#ea8685",
                    G: "#546de5",
                    H: "#e15f41",
                    I: "#c44569",
                    K: "#f8a5c2",
                    L: "#786fa6",
                    M: "#63cdda",
                    N: "#778beb",
                    P: "#596275",
                    Q: "#f19066",
                    R: "#f7d794",
                    S: "#574b90",
                    T: "#f78fb3",
                    U: "#34495e",
                    V: "#303952",
                    W: "#3dc1d3",
                    Y: "#e66767",
                    X: "#bdc3c7",
                    a: "#f3a683",
                    b: "#8e44ad",
                    c: "#cf6a87",
                    d: "#e77f67",
                    e: "#f5cd79",
                    f: "#ea8685",
                    g: "#546de5",
                    h: "#e15f41",
                    i: "#c44569",
                    k: "#f8a5c2",
                    l: "#786fa6",
                    m: "#63cdda",
                    n: "#778beb",
                    p: "#596275",
                    q: "#f19066",
                    r: "#f7d794",
                    s: "#574b90",
                    t: "#f78fb3",
                    u: "#34495e",
                    v: "#303952",
                    w: "#3dc1d3",
                    y: "#e66767",
                    x: "#bdc3c7",
                    " ": "transparent",
                    "-": "transparent",
                    "*": "#353b48",
                };

                // colors = {
                //     "A": "#CBCBCB",
                //     "B": "#CBCBCB",
                //     "C": "#CBCBCB",
                //     "D": "#546DE5",
                //     "E": "#546DE5",
                //     "F": "#CBCBCB",
                //     "G": "#CBCBCB",
                //     "H": "#CBCBCB",
                //     "I": "#CBCBCB",
                //     "K": "#CBCBCB",
                //     "L": "#CBCBCB",
                //     "M": "#CBCBCB",
                //     "N": "#CBCBCB",
                //     "P": "#CBCBCB",
                //     "Q": "#CBCBCB",
                //     "R": "#CBCBCB",
                //     "S": "#CBCBCB",
                //     "T": "#CBCBCB",
                //     "U": "#CBCBCB",
                //     "V": "#CBCBCB",
                //     "W": "#CBCBCB",
                //     "Y": "#CBCBCB",
                //     "X": "#CBCBCB",
                //     "a": "#f3a683",
                //     "b": "#8e44ad",
                //     "c": "#cf6a87",
                //     "d": "#e77f67",
                //     "e": "#f5cd79",
                //     "f": "#ea8685",
                //     "g": "#546de5",
                //     "h": "#e15f41",
                //     "i": "#c44569",
                //     "k": "#f8a5c2",
                //     "l": "#786fa6",
                //     "m": "#63cdda",
                //     "n": "#778beb",
                //     "p": "#596275",
                //     "q": "#f19066",
                //     "r": "#f7d794",
                //     "s": "#574b90",
                //     "t": "#f78fb3",
                //     "u": "#34495e",
                //     "v": "#303952",
                //     "w": "#3dc1d3",
                //     "y": "#e66767",
                //     "x": "#bdc3c7",
                //     " ": "transparent",
                //     "-": "transparent",
                //     "*": "#353b48",
                // };
                colors = this.get_raac_color1();
                let x =
                    params["aa"]["backgroundRect"][0] * (x_index - 1) +
                    params["global"]["padding"][3] +
                    params["header"]["backgroundRect"][0] +
                    1;
                motif_ele.forEach((motif_aa, y_index) => {
                    let score = motif_aa["score"];
                    let aa = motif_aa["aa"];
                    if (y_index === 0) {
                        scale_y = (y_axis_len / (aa_rect_h * max_score)) * score;
                        y =
                            y_axis_len -
                            55 * scale_y +
                            params["global"]["padding"][0];
                        // console.log("y_index", y_index, aa, y);
                    } else {
                        scale_y = (y_axis_len / (aa_rect_h * max_score)) * score;
                        y -= 55 * scale_y;
                        // console.log("y_index", y_index, aa, y);
                    }
                    this.svg
                        .append("path")
                        .attr("d", aa_dict[aa])
                        .attr("fill", colors[aa])
                        .attr(
                            "transform",
                            `translate(${x},${y})scale(${scale_x},${scale_y})`
                        );
                });
            },
            extract_features() {
                this.feature_names = {
                    // Domains & sites
                    DOMAIN: "Domain",
                    REGION: "Region",
                    MOTIF: "Motif",
                    METAL: "Metal binding",
                    SITE: "Site",
                    ACT_SITE: "Active site",
                    // Structural feature
                    HELIX: "Helix",
                    TURN: "Turn",
                    STRAND: "Strand",
                    // Molecule processing
                    SIGNAL: "Signal peptide",
                    // 'CHAIN': 'Chain',
                    // PTM
                    DISULFID: "Disulfide bond",
                    MOD_RES: "Modified residue",
                    CARBOHYD: "Glycosylation",
                    CROSSLNK: "Cross-link",
                    // Antigene
                    ANTIGEN: "Antibody binding",
                    // 'VARIANT': 'Variant',
                    // Sequence information
                    COMPBIAS: "Compositional bias",
                    // Topology
                    TOPO_DOM: "Topological domain",
                    TRANSMEM: "Transmembrane",
                };
                let feature_arr = Object.keys(this.feature_names);
                // console.log("feature_arr", feature_arr);
                let features_url =
                    "https://www.ebi.ac.uk/proteins/api/features/" +
                    this.current_protein["accession"];
                let antigen_url =
                    "https://www.ebi.ac.uk/proteins/api/antigen/" +
                    this.current_protein["accession"];
                this.seq_loading = true;
                let vue_obj = this;
                if (this.reload || this.is_init) {
                    this.feature_map = {};
                    axios.get(features_url).then((res) => {
                        res.data["features"].forEach((feature) => {
                            // console.log(feature['type'], feature_arr.indexOf(feature['type']))
                            if (feature_arr.indexOf(feature["type"]) >= 0) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        this.feature_map,
                                        feature["type"]
                                    )
                                ) {
                                    this.feature_map[feature["type"]].push({
                                        begin: Number(feature["begin"]),
                                        end: Number(feature["end"]),
                                        description: feature["description"],
                                        evidences: feature["evidences"],
                                    });
                                } else {
                                    this.feature_map[feature["type"]] = [{
                                        begin: Number(feature["begin"]),
                                        end: Number(feature["end"]),
                                        description: feature["description"],
                                        evidences: feature["evidences"],
                                    }, ];
                                }
                            }
                        });
                        axios
                            .get(antigen_url)
                            .then((res) => {
                                res.data["features"].forEach((feature) => {
                                    if (feature_arr.indexOf(feature["type"]) > 0) {
                                        if (
                                            Object.prototype.hasOwnProperty.call(
                                                this.feature_map,
                                                feature["type"]
                                            )
                                        ) {
                                            this.feature_map[feature["type"]].push({
                                                begin: Number(feature["begin"]),
                                                end: Number(feature["end"]),
                                                xrefs: feature["xrefs"],
                                                evidences: feature["evidences"],
                                            });
                                        } else {
                                            this.feature_map[feature["type"]] = [{
                                                begin: Number(feature["begin"]),
                                                end: Number(feature["end"]),
                                                xrefs: feature["xrefs"],
                                                evidences: feature["evidences"],
                                            }, ];
                                        }
                                    }
                                });
                                this.render_process();
                            })
                            .catch(function() {
                                vue_obj.render_process();
                            });
                    });
                } else {
                    this.render_process();
                }
            },
            render_features() {
                let num = 0;
                let tooltip = d3
                    .select("#seq_container")
                    .append("div")
                    .attr("id", "tooltip")
                    .attr("opacity", 0.0);
                let commit_data = [];
                let vue_obj = this;
                if (this.update_features.length > 0) {
                    let num = 0;
                    vue_obj.update_features.forEach(function(item) {
                        if (item["visible"]) {
                            vue_obj.render_feature(
                                num,
                                item["name"],
                                item["data"],
                                item["color"],
                                tooltip
                            );
                            num += 1;
                        }
                    });
                } else {
                    Object.getOwnPropertyNames(
                        Object.assign({}, this.feature_names)
                    ).forEach((feature_name) => {
                        if (
                            Object.prototype.hasOwnProperty.call(
                                this.feature_map,
                                feature_name
                            )
                        ) {
                            // console.log('feature_name', feature_name, this.feature_names[feature_name])
                            let feature = this.feature_names[feature_name];
                            let feature_data = this.feature_map[feature_name];
                            let feature_color = this.params[feature]["color"];
                            commit_data.push({
                                name: feature,
                                data: feature_data,
                                color: feature_color,
                                visible: true,
                            });
                            this.render_feature(
                                num,
                                feature,
                                feature_data,
                                feature_color,
                                tooltip
                            );
                            num += 1;
                        }
                    });
                    if (commit_data.length > 0)
                        this.$store.commit("featuresDataMutation", commit_data);
                }
                this.feature_num = num;
                this.seq_loading = false;
            },
            render_feature(num, feature, features_data, feature_color, tooltip) {
                let params = this.params;
                let reduce_height = params["header"]["backgroundRect"][1] * 6;
                // console.log("reduce_height", reduce_height);
                let seg_y =
                    params["feature"]["backgroundHeight"] * num +
                    reduce_height +
                    params["global"]["padding"][0] +
                    params["margin"]["top"] +
                    params["ruler"]["height"];

                if (num === 0) this.add_segmentation(seg_y);

                this.add_segmentation(
                    seg_y + params["feature"]["backgroundHeight"]
                );

                let height = params["feature"]["height"];
                let row_height = height;
                let previous_end = 0;
                let rows_num = 1;
                let rows = [];
                // console.log("feature", feature, features_data);

                features_data.forEach((feature_data) => {
                    let start = feature_data["begin"];
                    let end = feature_data["end"];
                    if (start < previous_end) {
                        // console.log('start < previous_end');
                        rows_num += 1;
                    } else {
                        rows_num = 1;
                    }
                    if (Array.prototype.hasOwnProperty.call(rows, rows_num - 1)) {
                        rows[rows_num - 1].push(feature_data);
                    } else {
                        rows[rows_num - 1] = [feature_data];
                    }
                    previous_end = end;
                });
                let rows_len = rows.length;
                if (rows_len > 1) {
                    row_height = rows_len / rows_len;
                    let padding = params["feature"]["padding"][0] / rows_len;
                    params["feature"]["padding"][0] = padding;
                    row_height =
                        (params["feature"]["backgroundHeight"] -
                            padding * 2 -
                            rows_len) /
                        rows_len;
                } else {
                    params["feature"]["padding"][0] = 9;
                    row_height = (height * 2) / 3;
                }
                let y = seg_y + params["feature"]["padding"][0];
                // console.log(feature, rows, rows.length);
                let vue_obj = this;
                rows.forEach((row, i) => {
                    i;
                    row.forEach((feature_data) => {
                        let start = feature_data["begin"];
                        let end = feature_data["end"];
                        let color = feature_color;
                        let width =
                            params["aa"]["backgroundRect"][0] * (end - start + 1);
                        let x =
                            params["aa"]["backgroundRect"][0] * (start - 1) +
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0];
                        let content =
                            `<i style="color:#8395a7; font-size: 18px; white-space: nowrap"><strong style="color:${color}">${feature}</strong>  <span style="font-size: 16px; margin-left: 5px;">${start}-${end}</span><br/><div style="white-space: nowrap">${description}</div></i>`;
                        let y_offset = i * row_height + i;
                        let tooltip_max_width = 0;
                        let tooltip_max_height = 0;
                        let description = "";
                        let des_width = 0;
                        let des_len = 0;
                        if (
                            feature_data["description"] !== undefined &&
                            feature_data["description"] !== null &&
                            feature_data["description"] !== ""
                        ) {
                            let feature_description = feature_data["description"];
                            let des_arr = feature_description.split(" ");
                            description = "<br/>";
                            des_arr.forEach((des, i) => {
                                if (i % 5 === 0 && i !== 0) {
                                    description += des + "<br/>";
                                } else {
                                    description += des + " ";
                                }
                            });
                            des_arr = description.split("<br/>");
                            des_arr.forEach((des) => {
                                let cur_len = des.length;
                                if (cur_len > des_len) des_len = cur_len;
                            });
                            des_width = des_len * 8 + 20;
                            // console.log("des_len", des_len, des_width, description)
                        }
                        // let char_len = 0;
                        switch (feature) {
                            default: {
                                let evidences = feature_data["evidences"];
                                let descr = [];
                                let pos_char = "";
                                if (start === end) {
                                    pos_char = start;
                                } else {
                                    pos_char = `${start}-${end}`;
                                }
                                tooltip_max_width =
                                    `${feature}  ${start}, ${end}`.length * 9 + 20;

                                if (evidences !== undefined && evidences !== null) {
                                    evidences.forEach((evidence) => {
                                        let code_len = 0;
                                        let code_char = "";
                                        let id_len = 0;
                                        let id_char = "";

                                        if (
                                            evidence["code"] !== undefined &&
                                            evidence["code"] !== null
                                        ) {
                                            code_char =
                                                `<strong>Evidence</strong>  ${evidence["code"]}`;
                                            code_len = evidence["code"].length;
                                        }
                                        if (
                                            evidence["source"] !== undefined &&
                                            evidence["source"] !== null &&
                                            evidence["source"]["id"] !==
                                            undefined &&
                                            evidence["source"]["id"] !== null
                                        ) {
                                            id_char =
                                                ` (<a href="${evidence["source"]["url"]}" target="_blank">${evidence["source"]["id"]}</a>)`;
                                            id_len =
                                                evidence["source"]["id"].length;
                                        }
                                        if (
                                            evidence["xrefs"] !== undefined &&
                                            evidence["xrefs"] !== null
                                        ) {
                                            feature_data["xrefs"].forEach(
                                                (xref) => {
                                                    descr.push(
                                                        `<strong>Match</strong>  ${xref["name"]} (<a href="${xref["url"]}" target="_blank">${xref["id"]}</a>)`
                                                    );
                                                }
                                            );
                                        }

                                        let cur_width =
                                            (code_len + id_len + 12) * 9 + 20;
                                        if (tooltip_max_width < cur_width) {
                                            tooltip_max_width = cur_width;
                                        }

                                        // if(tooltip_max_height)
                                        // console.log("char_len", evidence['code'], evidence['code'].length,  evidence['source']['id'], evidence['source']['id'].length, char_len)
                                        descr.push(`${code_char}${id_char}`);
                                    });
                                }
                                if (tooltip_max_width < des_width) {
                                    tooltip_max_width = des_width;
                                }
                                tooltip_max_height = descr.length * 25 + 67;
                                if (descr.length > 0) {
                                    content = `<i style="color:#8395a7; font-size: 18px; white-space: nowrap"><strong style="color:${color}">${feature}</strong><span style="font-size: 16px; margin-left: 5px;">${pos_char}</span><span style="float: right;padding-top: 5px;cursor: pointer" class="el-icon-close" onclick="document.getElementById('tooltip').style.display = 'none'"></span>${description}<br/>${descr.join(
                                    "<br/>"
                                )}</i>`;
                                } else {
                                    content = `<i style="color:#8395a7; font-size: 18px; white-space: nowrap"><strong style="color:${color}">${feature}</strong><span style="font-size: 16px; margin-left: 5px;">${pos_char}</span><span style="padding-top: 5px;margin-left: 15px;cursor: pointer" class="el-icon-close" onclick="document.getElementById('tooltip').style.display = 'none'"></span>${description}<br/>${descr.join(
                                    "<br/>"
                                )}</i>`;
                                }
                                break;
                            }
                        }

                        let selected_flag = false;
                        switch (feature) {
                            case "Disulfide bond": {
                                let point = params["aa"]["backgroundRect"][0];
                                let mid_width =
                                    params["aa"]["backgroundRect"][0] *
                                    (end - start);
                                let group = this.svg.append("g");
                                group
                                    .append("rect")
                                    .attr("width", point)
                                    .attr("height", row_height)
                                    .attr("x", x)
                                    .attr("y", y + y_offset)
                                    .attr("ry", 2)
                                    .attr("ry", 2)
                                    .attr("text-anchor", "middle")
                                    .attr("fill", color)
                                    .attr("style", "cursor:pointer");
                                group
                                    .append("rect")
                                    .attr("width", mid_width)
                                    .attr("height", row_height)
                                    .attr("x", x + point)
                                    .attr("y", y + y_offset)
                                    .attr("ry", 2)
                                    .attr("ry", 2)
                                    .attr("text-anchor", "middle")
                                    .attr("fill", "#ced6e0")
                                    .attr("style", "cursor:pointer");
                                group
                                    .append("rect")
                                    .attr("width", point)
                                    .attr("height", row_height)
                                    .attr("x", x + mid_width)
                                    .attr("y", y + y_offset)
                                    .attr("ry", 2)
                                    .attr("ry", 2)
                                    .attr("text-anchor", "middle")
                                    .attr("fill", color)
                                    .attr("style", "cursor:pointer");

                                group
                                    .on("mousemove", function() {
                                        if (!selected_flag) {
                                            // let style = `position:absolute;left:${d3.event.layerX + 20}px;top:${d3.event.layerY}px;font-family: "Source Sans Pro"; box-shadow: rgb(0 0 0 / 20%) 1px 2px 10px; font-size: 16px; border-radius: 4px; z-index: 9999999; border: 1px solid ${color}; background-color: white; border-radius: 5px; color: rgb(102, 102, 102); transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;padding: 5px 10px;`;
                                            let style = "";
                                            let x = d3.event.layerX + 20;
                                            let y = d3.event.layerY;
                                            if (
                                                tooltip_max_width +
                                                d3.event.pageX -
                                                window.innerWidth >
                                                0
                                            ) {
                                                x =
                                                    d3.event.layerX -
                                                    tooltip_max_width +
                                                    20;
                                                // style = `position:absolute;left:${x}px;top:${y}px;font-family: "Source Sans Pro"; box-shadow: rgb(0 0 0 / 20%) 1px 2px 10px; font-size: 16px; border-radius: 4px; z-index: 9999999; border: 1px solid ${color}; background-color: white; border-radius: 5px; color: rgb(102, 102, 102); transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;padding: 5px 10px;`;
                                            }
                                            if (
                                                tooltip_max_height +
                                                d3.event.pageY -
                                                window.innerHeight >
                                                0
                                            ) {
                                                y =
                                                    d3.event.layerY -
                                                    tooltip_max_height;
                                            }
                                            style =
                                                `position:absolute;left:${x}px;top:${y}px;font-family: "Source Sans Pro"; box-shadow: rgb(0 0 0 / 20%) 1px 2px 10px; font-size: 16px; border-radius: 4px; z-index: 9999999; border: 1px solid ${color}; background-color: white; border-radius: 5px; color: rgb(102, 102, 102); transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;padding: 5px 10px;`;

                                            // console.log(x, y, window.innerHeight, tooltip_max_height, d3.event.pageY, tooltip_max_height + d3.event.pageY - window.innerHeight);

                                            tooltip
                                                .attr("style", style)
                                                .attr("opacity", 1)
                                                .html(content);
                                        }
                                    })
                                    .on("mouseout", function() {
                                        if (!selected_flag) {
                                            tooltip.attr("style", "display: none;");
                                        }
                                    })
                                    .on("click", function() {
                                        selected_flag = true;
                                        let selected = {
                                            start: start,
                                            end: end,
                                            shape: "point",
                                            color: color,
                                        };
                                        vue_obj.$store.commit(
                                            "selectedRangeMutation",
                                            selected
                                        );
                                        let style = "";
                                        let tpx = d3.event.layerX + 20;
                                        let tpy = d3.event.layerY;
                                        if (
                                            tooltip_max_width +
                                            d3.event.pageX -
                                            window.innerWidth >
                                            0
                                        ) {
                                            tpx =
                                                d3.event.layerX -
                                                tooltip_max_width +
                                                20;
                                        }
                                        if (
                                            tooltip_max_height +
                                            d3.event.pageY -
                                            window.innerHeight >
                                            0
                                        ) {
                                            tpy =
                                                d3.event.layerY -
                                                tooltip_max_height;
                                        }
                                        style =
                                            `position:absolute;left:${tpx}px;top:${tpy}px;font-family: "Source Sans Pro"; box-shadow: rgb(0 0 0 / 20%) 1px 2px 10px; font-size: 16px; border-radius: 4px; z-index: 9999999; border: 1px solid ${color}; background-color: white; border-radius: 5px; color: rgb(102, 102, 102); transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;padding: 5px 10px;`;
                                        tooltip
                                            .attr("style", style)
                                            .attr("opacity", 1)
                                            .html(content);

                                        vue_obj.add_flag_tag(
                                            mid_width,
                                            x,
                                            "point2"
                                        );
                                    });
                                selected_flag = false;
                                break;
                            }

                            default: {
                                this.svg
                                    .append("rect")
                                    .attr("width", width)
                                    .attr("height", row_height)
                                    .attr("x", x)
                                    .attr("y", y + y_offset)
                                    .attr("ry", 2)
                                    .attr("ry", 2)
                                    .attr("text-anchor", "middle")
                                    .attr("fill", color)
                                    .attr("style", "cursor:pointer")
                                    .on("mousemove", function() {
                                        if (!selected_flag) {
                                            let style = "";
                                            let x = d3.event.layerX + 20;
                                            let y = d3.event.layerY;
                                            if (
                                                tooltip_max_width +
                                                d3.event.pageX -
                                                window.innerWidth >
                                                0
                                            ) {
                                                x =
                                                    d3.event.layerX -
                                                    tooltip_max_width +
                                                    20;
                                            }
                                            tooltip_max_height;
                                            if (
                                                tooltip_max_height +
                                                d3.event.pageY -
                                                window.innerHeight >
                                                0
                                            ) {
                                                y =
                                                    d3.event.layerY -
                                                    tooltip_max_height;
                                            }
                                            style =
                                                `position:absolute;left:${x}px;top:${y}px;font-family: "Source Sans Pro"; box-shadow: rgb(0 0 0 / 20%) 1px 2px 10px; font-size: 16px; border-radius: 4px; z-index: 9999999; border: 1px solid ${color}; background-color: white; border-radius: 5px; color: rgb(102, 102, 102); transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;padding: 5px 10px;`;
                                            tooltip
                                                .attr("style", style)
                                                .attr("opacity", 1)
                                                .html(content);
                                        }
                                    })
                                    .on("mouseout", function() {
                                        if (!selected_flag) {
                                            tooltip.attr("style", "display: none;");
                                        }
                                    })
                                    .on("click", function() {
                                        selected_flag = true;
                                        let selected = {
                                            start: start,
                                            end: end,
                                            color: color,
                                        };
                                        vue_obj.$store.commit(
                                            "selectedRangeMutation",
                                            selected
                                        );
                                        let style = "";
                                        let tpx = d3.event.layerX + 20;
                                        let tpy = d3.event.layerY;
                                        if (
                                            tooltip_max_width +
                                            d3.event.pageX -
                                            window.innerWidth >
                                            0
                                        ) {
                                            tpx =
                                                d3.event.layerX -
                                                tooltip_max_width +
                                                20;
                                        }
                                        if (
                                            tooltip_max_height +
                                            d3.event.pageY -
                                            window.innerHeight >
                                            0
                                        ) {
                                            tpy =
                                                d3.event.layerY -
                                                tooltip_max_height;
                                        }
                                        style =
                                            `position:absolute;left:${tpx}px;top:${tpy}px;font-family: "Source Sans Pro"; box-shadow: rgb(0 0 0 / 20%) 1px 2px 10px; font-size: 16px; border-radius: 4px; z-index: 9999999; border: 1px solid ${color}; background-color: white; border-radius: 5px; color: rgb(102, 102, 102); transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;padding: 5px 10px;`;
                                        tooltip
                                            .attr("style", style)
                                            .attr("opacity", 1)
                                            .html(content);
                                        vue_obj.add_flag_tag(width, x, "rect");
                                    });
                                break;
                            }
                        }
                    });
                });
                // console.log("rows_num", rows_num);
                let font_pre = {
                    Domain: 44,
                    Region: 40,
                    Helix: 28,
                    "Modified residue": 108,
                    "Cross-link": 60,
                    "Antibody binding": 108,
                    Strand: 39,
                    "Compositional bias": 123,
                    "Active site": 60,
                    Turn: 25,
                    "Signal peptide": 88,
                    "Disulfide bond": 90,
                    Glycosylation: 93,
                    "Metal binding": 88,
                    Motif: 31,

                    Site: 25,
                    "Topological domain": 123,
                    Transmembrane: 15,
                    XXXX: 1,
                };
                // header ----------------------------------------------------------------------------------------------------------------------------
                this.svg
                    .append("rect")
                    .attr("width", params["header"]["backgroundRect"][0])
                    .attr("height", params["header"]["backgroundRect"][1])
                    .attr("x", params["global"]["padding"][3])
                    .attr("y", y)
                    .attr("text-anchor", "right")
                    .attr("fill", params["header"]["background"]);
                this.svg
                    .append("text")
                    .text(feature)
                    .attr("font-size", params["header"]["fontSize"])
                    .attr("font-family", params["header"]["fontFamily"])
                    .attr("fill", params["header"]["color"])
                    .attr(
                        "x",
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0] -
                        (font_pre[feature] + params["header"]["padding"][1])
                    )
                    .attr("y", y)
                    .attr(
                        "dy",
                        params["header"]["backgroundRect"][1] +
                        params["header"]["padding"][0]
                    );
            },
            add_flag_tag(width, x, shape) {
                let child_nodes = this.selecter_tag.selectAll("*");
                let point = this.params["aa"]["backgroundRect"][0];
                // let selected_tag_y = this.params['ruler']['height'] - this.params['ruler']['strokeWidth'] + this.params['global']['padding'][0] + this.params['aa']['backgroundPadding'][0] + this.params['header']['backgroundRect'][1] - 5
                let selected_tag_y =
                    this.params["header"]["backgroundRect"][1] * 3 -
                    9 -
                    this.params["ruler"]["strokeWidth"] +
                    this.params["global"]["padding"][0] +
                    this.params["aa"]["backgroundPadding"][0];
                let selected_tag_height = this.params["ruler"]["strokeWidth"];
                let selected_region_y = this.params["global"]["padding"][0];
                // console.log("this.selecter_tag", this.selecter_tag, child_nodes[0][0]);
                if (child_nodes[0][0] !== undefined) {
                    child_nodes.remove();
                    this.selector_region.selectAll("*").remove();
                }
                if (shape === "rect") {
                    this.selecter_tag
                        .append("rect")
                        .attr("width", width)
                        .attr("height", selected_tag_height)
                        .attr("x", x)
                        .attr("y", selected_tag_y)
                        .attr("style", "fill:red;");
                    this.selector_region
                        .append("rect")
                        .attr("width", width)
                        .attr("height", this.selected_height)
                        .attr("x", x)
                        .attr("y", selected_region_y)
                        .attr("fill", this.params["selected"]["color"]);
                } else if (shape === "point2") {
                    this.selecter_tag
                        .append("rect")
                        .attr("width", point)
                        .attr("height", selected_tag_height)
                        .attr("x", x)
                        .attr("y", selected_tag_y)
                        .attr("style", "fill:red;");
                    this.selecter_tag
                        .append("rect")
                        .attr("width", point)
                        .attr("height", selected_tag_height)
                        .attr("x", x + width)
                        .attr("y", selected_tag_y)
                        .attr("style", "fill:red;");

                    this.selector_region
                        .append("rect")
                        .attr("width", point)
                        .attr("height", this.selected_height)
                        .attr("x", x)
                        .attr("y", this.params["global"]["padding"][0])
                        .attr("fill", this.params["selected"]["color"]);
                    this.selector_region
                        .append("rect")
                        .attr("width", point)
                        .attr("height", this.selected_height)
                        .attr("x", x + width)
                        .attr("y", this.params["global"]["padding"][0])
                        .attr("fill", this.params["selected"]["color"]);
                }
            },
            add_ruler(seq) {
                let params = this.params;
                let seq_len = seq.length;
                let y =
                    6 +
                    params["global"]["padding"][0] +
                    params["header"]["backgroundRect"][1] +
                    params["ruler"]["height"] -
                    this.params["scale"]["height"] -
                    1;
                this.svg
                    .append("line")
                    .attr(
                        "x1",
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0]
                    )
                    .attr("y1", y)
                    .attr(
                        "x2",
                        params["header"]["backgroundRect"][0] +
                        seq_len * params["aa"]["backgroundRect"][0] +
                        params["global"]["padding"][3]
                    )
                    .attr("y2", y)
                    .attr(
                        "style",
                        `stroke:${params["ruler"]["color"]};stroke-width:${params["ruler"]["strokeWidth"]}`
                    );
                for (let i = 0; i < seq_len; i++) {
                    this.add_scale(i);
                }
                this.selecter_tag = this.svg.append("g").attr("id", "selecter_tag");
            },
            add_scale(i) {
                let y =
                    6 +
                    this.params["global"]["padding"][0] +
                    this.params["header"]["backgroundRect"][1] +
                    this.params["ruler"]["height"] -
                    this.params["scale"]["height"] -
                    1;
                let x =
                    this.params["global"]["padding"][3] +
                    this.params["header"]["backgroundRect"][0] +
                    this.params["aa"]["backgroundRect"][0] / 2 +
                    this.params["aa"]["backgroundRect"][0] * i;
                let l_scale = 0;
                if ((i + 1) % this.params["scale"]["interval"] === 0 || i === 0) {
                    l_scale = this.params["scale"]["height"];
                    this.svg
                        .append("text")
                        .text(i + 1)
                        .attr("fill", this.params["scale"]["color"])
                        .attr("font-size", this.params["scale"]["fontSize"])
                        .attr("x", x)
                        .attr("y", y + l_scale - 2)
                        .attr("text-anchor", "middle")
                        // .attr("dominant-baseline","middle")
                        .attr("dx", this.params["scale"]["offset"][0])
                        .attr("dy", this.params["scale"]["offset"][1]);
                }

                this.svg
                    .append("line")
                    .attr("x1", x)
                    .attr("y1", y)
                    .attr("x2", x)
                    .attr("y2", y + l_scale)
                    .attr(
                        "style",
                        `stroke:${this.params["ruler"]["color"]};stroke-width:${this.params["ruler"]["strokeWidth"]}`
                    );
            },
            add_header(text, num, is_feature) {
                let params = this.params;
                let offset = 0;
                if (is_feature) {
                    offset = params["margin"]["top"];
                }
                if (text === "") {
                    return 0;
                }
                this.svg
                    .append("rect")
                    .attr("width", params["header"]["backgroundRect"][0])
                    .attr("height", params["header"]["backgroundRect"][1])
                    .attr("x", params["global"]["padding"][3])
                    .attr(
                        "y",
                        offset +
                        params["ruler"]["height"] +
                        params["global"]["padding"][0] +
                        params["header"]["backgroundRect"][1] * num
                    )
                    .attr("text-anchor", "right")
                    .attr("fill", params["header"]["background"]);
                // .attr('fill', 'red');

                let font_pre = {
                    Reduced: 48,
                    Natural: 41,
                    Query: 34,
                    Confidence: 66,
                    Conservative: 78,
                    PDB: 21,
                };
                this.svg
                    .append("text")
                    .text(text)
                    .attr("id", text.replace(" ", "_"))
                    .attr("font-size", params["header"]["fontSize"])
                    .attr("font-family", params["header"]["fontFamily"])
                    .attr("fill", params["header"]["color"])
                    .attr(
                        "x",
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0] -
                        (font_pre[text] + params["header"]["padding"][1])
                    )
                    .attr(
                        "y",
                        offset +
                        params["ruler"]["height"] +
                        params["global"]["padding"][0] +
                        params["header"]["backgroundRect"][1] * num
                    )
                    .attr(
                        "dy",
                        params["header"]["backgroundRect"][1] +
                        params["header"]["padding"][0]
                    );
                // console.log("width", d3.select("#" + text.replace(" ", "_")).style("width"));
                // console.log("width", document.getElementById(text.replace(" ", "_")), document.getElementById(text.replace(" ", "_")).offsetHeight)
            },
            add_segmentation(y) {
                let params = this.params;
                this.svg
                    .append("rect")
                    .attr(
                        "width",
                        params["header"]["backgroundRect"][0] +
                        this.seq_len * params["aa"]["backgroundRect"][0] +
                        params["global"]["padding"][3]
                    )
                    .attr("height", "0.5px")
                    .attr(
                        "x",
                        params["global"]["padding"][3] +
                        params["header"]["backgroundRect"][0]
                    )
                    .attr("y", y)
                    .attr("fill", params["segmentation"]["color"]);
                // this.svg.append('line')
                //     .attr('x1', params['global']['padding'][3] + params['header']['backgroundRect'][0])
                //     .attr('y1', y)
                //     .attr('x2', params['header']['backgroundRect'][0] + this.seq_len * params['aa']['backgroundRect'][0] + params['global']['padding'][3])
                //     .attr('y2', y)
                //     .attr('style', `stroke:${params['segmentation']['color']};stroke-width:${params['segmentation']['height']}`);
            },
            add_select_layer(seq) {
                let params = this.params;
                let selecter_g = this.svg.append("g").attr("id", "selecter");
                // let selected_tag_y = this.params['ruler']['height'] - this.params['ruler']['strokeWidth'] + this.params['global']['padding'][0]
                let selected_tag_y =
                    this.params["header"]["backgroundRect"][1] * 3 -
                    9 -
                    this.params["ruler"]["strokeWidth"] +
                    this.params["global"]["padding"][0] +
                    this.params["aa"]["backgroundPadding"][0];

                let selected_tag_height = this.params["ruler"]["strokeWidth"];
                let selected_region_y = this.params["global"]["padding"][0] - 4;

                let selecter_g_rect = null;
                let current_x = 0;
                let selected = this.selected;
                selected["start"] = [];
                selected["end"] = [];
                let start = 0;
                let start_x = 0;
                let vue_obj = this;
                for (let i = 0; i < seq.length; i++) {
                    let aa = seq[i];
                    var flag = 0;

                    // 游标渲染 ===============================================================
                    this.cursor
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr("height", this.selected_height)
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["fontSize"] * i
                        )
                        .attr("y", params["global"]["padding"][0])
                        .attr("text-anchor", "middle")
                        .attr("style", "fill:transparent;")
                        .attr("id", aa)
                        .attr("num", i + 1)
                        .on("mousemove", function() {
                            d3.select(this).attr(
                                "style",
                                "fill:rgba(84, 160, 255,0.4);"
                            );
                        })
                        .on("mouseout", function() {
                            if (current_x != d3.select(this).attr("x")) {
                                d3.select(this).attr("style", "fill:transparent;");
                            }
                        });

                    this.svg
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr(
                            "height",
                            params["aa"]["backgroundRect"][1] * 7 +
                            params["feature"]["backgroundHeight"] *
                            this.feature_num +
                            params["ruler"]["height"] +
                            params["scale"]["height"]
                        )
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["fontSize"] * i
                        )
                        .attr("y", params["global"]["padding"][0] - 4)
                        .attr("text-anchor", "middle")
                        .attr("style", "fill:transparent;")
                        .attr("id", aa)
                        .attr("num", i + 1)
                        .on("contextmenu", function() {
                            d3.event.preventDefault();
                            // console.log("d3.select(this)",e,i)
                            // react on right-clicking
                        })
                        .on("mousedown", function() {
                            // console.log("mousedown", d3.event.button);
                            // 左键单击触发 ==================================
                            if (d3.event.button === 0) {
                                if (vue_obj.menu_show) {
                                    vue_obj.menu_show = false;
                                    let sequence_menu =
                                        vue_obj.$store.state.sequence_menu;
                                    sequence_menu["isshow"] = vue_obj.menu_show;
                                    vue_obj.$store.commit(
                                        "sequenceMenuMutation",
                                        sequence_menu
                                    );
                                }
                                selecter_g;
                                flag = 1;
                                let x = d3.select(this).attr("x");
                                start_x = x;
                                selecter_g;
                                // 清除之前的选择区域 ========================
                                // console.log(
                                //     "vue_obj.multi_sequence",
                                //     vue_obj.multi_sequence
                                // );
                                if (!vue_obj.multi_sequence) {
                                    let child_nodes =
                                        vue_obj.selecter_tag.selectAll("*");
                                    if (child_nodes[0][0] !== undefined) {
                                        child_nodes.remove();
                                    }
                                    let selector_region_nodes =
                                        vue_obj.selector_region.selectAll("*");
                                    if (selector_region_nodes[0][0] !== undefined) {
                                        selector_region_nodes.remove();
                                    }
                                    selected["start"] = [
                                        d3.select(this).attr("num"),
                                    ];
                                } else {
                                    selected["start"].push(
                                        d3.select(this).attr("num")
                                    );
                                }
                                selecter_g_rect = vue_obj.selecter_tag
                                    .append("rect")
                                    .attr(
                                        "width",
                                        params["aa"]["backgroundRect"][0]
                                    )
                                    .attr("height", selected_tag_height)
                                    .attr("x", x)
                                    .attr("y", selected_tag_y)
                                    .attr("style", "fill:red;");
                                start = d3.select(this).attr("num");
                            }
                        })
                        .on("mousemove", function() {
                            // let x = d3.select(this).attr("x");
                            // if (!vue_obj.menu_show) {
                            d3.select(this).attr(
                                "style",
                                "fill:rgba(84, 160, 255,0.4);"
                            );
                            if (flag) {
                                let len = d3.select(this).attr("num") - start + 1;
                                selecter_g_rect
                                    .attr(
                                        "width",
                                        params["aa"]["backgroundRect"][0] * len
                                    )
                                    .attr("height", selected_tag_height)
                                    .attr("x", start_x)
                                    .attr("y", selected_tag_y)
                                    // .attr('style', 'fill:transparent;')
                                    .attr("style", "fill:red;");
                            }
                            // }
                        })
                        .on("mouseout", function() {
                            if (d3.event.button === 0) {
                                if (current_x != d3.select(this).attr("x")) {
                                    d3.select(this).attr(
                                        "style",
                                        "fill:transparent;"
                                    );
                                }
                            }
                        })
                        .on("mouseup", function() {
                            let sequence_menu = vue_obj.$store.state.sequence_menu;
                            if (d3.event.button === 0) {
                                flag = 0;
                                // console.log("mouseup", d3.event.button);
                                let len = d3.select(this).attr("num") - start + 1;
                                let width = params["aa"]["backgroundRect"][0] * len;
                                if (!vue_obj.multi_sequence) {
                                    selected["end"] = [d3.select(this).attr("num")];
                                } else {
                                    selected["end"].push(
                                        d3.select(this).attr("num")
                                    );
                                }
                                width;
                                vue_obj.$store.commit(
                                    "selectedRangeMutation",
                                    selected
                                );
                                if (start_x > 0) {
                                    vue_obj.selector_region
                                        .append("rect")
                                        .attr("width", width)
                                        .attr("height", vue_obj.selected_height)
                                        .attr("x", start_x)
                                        .attr("y", selected_region_y)
                                        .attr(
                                            "fill",
                                            vue_obj.params["selected"]["color"]
                                        );
                                }

                                let current_pos = parseInt(
                                    d3.select(this).attr("num")
                                );
                                let selected_range =
                                    vue_obj.$store.state.selected_range;
                                // console.log("current_pos", current_pos);
                                // console.log("selected_range", selected_range);
                                let start_arr = selected_range["start"];
                                let end_arr = selected_range["end"];

                                for (let i = 0; i < start_arr.length; i++) {
                                    let start = parseInt(start_arr[i]);
                                    let end = parseInt(end_arr[i]);
                                    if (current_pos >= start && current_pos <= end) {
                                        if (Object.prototype.hasOwnProperty.call(sequence_menu, "color")) {
                                            // if (!Object.prototype.hasOwnProperty.call(sequence_menu["color"], i)) {
                                                sequence_menu["color"][i] = "";
                                            // }
                                        } else {
                                            sequence_menu["color"][i] = "";
                                        }

                                        if (Object.prototype.hasOwnProperty.call(sequence_menu, "representation")) {
                                            // if (!Object.prototype.hasOwnProperty.call(sequence_menu["representation"], i)) {
                                                sequence_menu["representation"][i] = "";
                                            // }
                                        } else {
                                            sequence_menu["representation"][i] = "";
                                        }

                                        // if (Object.prototype.hasOwnProperty.call(sequence_menu, "focus")) {
                                        //     if (!Object.prototype.hasOwnProperty.call(sequence_menu["focus"], i)) {
                                        //         sequence_menu["focus"][i] = "";
                                        //     }
                                        // } else {
                                        //     sequence_menu["focus"] = new Array("");
                                        // }

                                        if (Object.prototype.hasOwnProperty.call(sequence_menu, "delete")) {
                                            // if (!Object.prototype.hasOwnProperty.call(sequence_menu["delete"], i)) {
                                                sequence_menu["delete"][i] = false;
                                            // }
                                        } else {
                                            sequence_menu["delete"] = new Array("");
                                        }

                                        // console.log("sequence_menu>>>", sequence_menu)
                                        sequence_menu["range"] = selected;
                                        vue_obj.$store.commit("sequenceMenuMutation", sequence_menu);
                                    }
                                }
                            } else if (d3.event.button === 2) {
                                // 判断右键所在选区
                                let current_pos = parseInt(
                                    d3.select(this).attr("num")
                                );
                                let selected_range = vue_obj.$store.state.selected_range;
                                // console.log("current_pos", current_pos);
                                // console.log("selected_range", selected_range);
                                let start_arr = selected_range["start"];
                                let end_arr = selected_range["end"];

                                for (let i = 0; i < start_arr.length; i++) {
                                    let start = parseInt(start_arr[i]);
                                    let end = parseInt(end_arr[i]);
                                    if (
                                        current_pos >= start &&
                                        current_pos <= end
                                    ) {
                                        // console.log(start, current_pos, end);
                                        sequence_menu["x"] = event["screenX"];
                                        sequence_menu["y"] = d3.mouse(this)[1];
                                        sequence_menu["range"] = selected;
                                        sequence_menu["index"] = i;
                                        // sequence_menu["multi_region"] = vue_obj.menu_show;
                                        vue_obj.menu_show = true;
                                        sequence_menu["isshow"] = vue_obj.menu_show;
                                        vue_obj.$store.commit("sequenceMenuMutation", sequence_menu);
                                        // console.log(
                                        //     "sequence_menu >>> ",
                                        //     sequence_menu
                                        // );
                                    }
                                }
                            }
                        });
                }
            },

            add_midline(seq, num, is_mid_str) {
                let params = this.params;
                for (let i = 0; i < seq.length; i++) {
                    let mid_str = "|";
                    if (is_mid_str) {
                        mid_str = this.align_mid[i];
                    }
                    this.svg
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr("height", params["aa"]["backgroundRect"][1])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["aa"]["backgroundPadding"][3] +
                            params["aa"]["fontSize"] * i
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] +
                            params["global"]["padding"][0] +
                            params["aa"]["backgroundPadding"][0]
                        )
                        .attr("text-anchor", "middle")
                        .attr("fill", params["midline"]["background"]);
                    this.svg
                        .append("text")
                        .text(mid_str)
                        .attr("fill", params["midline"]["color"])
                        .attr("font-size", params["aa"]["fontSize"])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] / 2 +
                            params["aa"]["fontSize"] * i
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["padding"][0]
                        )
                        .attr("text-anchor", "middle")
                        .attr("dx", params["aa"]["offset"][0])
                        .attr("dy", params["aa"]["offset"][1]);
                }
            },
            get_raac_color() {
                let raac_scheme = this.$store.state.raac_scheme;
                let raac_color = this.$store.state.raac_color;
                let color_map = {};
                raac_scheme.forEach((item, i) => {
                    let replace_aa = item.substr(0, 1);
                    color_map[replace_aa] = raac_color[i];
                });
                // console.log(raac_scheme)
                return color_map;
            },
            get_raac_color1() {
                let raac_scheme = this.$store.state.raac_scheme;
                let raac_color = this.$store.state.raac_color;
                let color_map = {};
                raac_scheme.forEach((item, i) => {
                    // let replace_aa = item.substr(0, 1);
                    let replace_arr = Array.from(item);
                    replace_arr.forEach((aa) => {
                        color_map[aa] = raac_color[i];
                    });
                });
                // console.log(raac_scheme)
                return color_map;
            },
            add_aa(seq, num, is_reduce) {
                let params = this.params;

                let colors = {
                    A: "#f3a683",
                    B: "#8e44ad",
                    C: "#cf6a87",
                    D: "#e77f67",
                    E: "#f5cd79",
                    F: "#ea8685",
                    G: "#546de5",
                    H: "#e15f41",
                    I: "#c44569",
                    K: "#f8a5c2",
                    L: "#786fa6",
                    M: "#63cdda",
                    N: "#778beb",
                    P: "#596275",
                    Q: "#f19066",
                    R: "#f7d794",
                    S: "#574b90",
                    T: "#f78fb3",
                    U: "#34495e",
                    V: "#303952",
                    W: "#3dc1d3",
                    Y: "#e66767",
                    X: "#bdc3c7",
                    a: "#f3a683",
                    b: "#8e44ad",
                    c: "#cf6a87",
                    d: "#e77f67",
                    e: "#f5cd79",
                    f: "#ea8685",
                    g: "#546de5",
                    h: "#e15f41",
                    i: "#c44569",
                    k: "#f8a5c2",
                    l: "#786fa6",
                    m: "#63cdda",
                    n: "#778beb",
                    p: "#596275",
                    q: "#f19066",
                    r: "#f7d794",
                    s: "#574b90",
                    t: "#f78fb3",
                    u: "#34495e",
                    v: "#303952",
                    w: "#3dc1d3",
                    y: "#e66767",
                    x: "#bdc3c7",
                    " ": "transparent",
                    "-": "transparent",
                    "*": "#353b48",
                };
                if (is_reduce) {
                    colors = this.get_raac_color();
                }
                for (let i = 0; i < seq.length; i++) {
                    let aa = seq[i];
                    // console.log(i, aa);
                    this.svg
                        .append("rect")
                        .attr("width", params["aa"]["backgroundRect"][0])
                        .attr("height", params["aa"]["backgroundRect"][1])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] * i
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["backgroundPadding"][0]
                        )
                        .attr("text-anchor", "middle")
                        .attr("fill", colors[aa]);

                    this.svg
                        .append("text")
                        .text(aa)
                        .attr("fill", params["aa"]["color"])
                        .attr("font-size", params["aa"]["fontSize"])
                        .attr(
                            "x",
                            params["global"]["padding"][3] +
                            params["header"]["backgroundRect"][0] +
                            params["aa"]["backgroundRect"][0] / 2 +
                            params["aa"]["fontSize"] * i
                        )
                        .attr(
                            "y",
                            this.params["ruler"]["height"] +
                            params["header"]["backgroundRect"][1] * num +
                            params["global"]["padding"][0] +
                            params["aa"]["padding"][0]
                        )
                        .attr("text-anchor", "middle")
                        // .attr("dominant-baseline","middle")
                        .attr("dx", params["aa"]["offset"][0])
                        .attr("dy", params["aa"]["offset"][1]);
                }
            },

            get_align_seq() {
                let current_accession = this.current_protein["accession"];
                let align_seq = "";
                let align_mid = "";
                this.naural_seq = this.align_hits["natural"];
                let source_db = this.current_protein['source_db'];
                let pdb_offset = 0;
                let pdb_id = 0;
                if(source_db === "PDB") {
                    pdb_offset = this.current_protein['pdb_start']
                    pdb_id = this.current_protein['pdb_id']
                }
                this.align_hits["hits"].forEach((hit) => {
                    let sep = hit["description"][0]["title"].split("|");
                    let hit_accession =sep[1];
                    let source_db =sep[0];
                    let hit_pdb_id = 0;
                    if(source_db === "pdb") hit_pdb_id = sep[6];
                    if (hit_accession === current_accession && pdb_id === hit_pdb_id) {
                        let hsps = hit["hsps"];
                        let query_len = hit["len"];
                        align_seq = " ".repeat(query_len);
                        align_mid = " ".repeat(query_len);
                        hsps.forEach((hsp) => {
                            let hit_from = hsp["hit_from"] + pdb_offset;
                            let hit_to = hsp["hit_to"];
                            // let query_from = hsp['query_from'];
                            let hseq = hsp["hseq"];
                            let midline = hsp["midline"];
                            let qseq = hsp["qseq"];
                            // align_seq = this.insert_str(align_seq, hit_from, hit_to, qseq);
                            // align_seq = this.insert_str(align_seq, hit_from + 1 - query_from, hit_to, qseq);
                            // align_seq = this.insert_str(align_seq, query_from, hit_to, qseq);
                            let res = [];
                            let res_mid = [];
                            for (let i = 0; i < hseq.length; i++) {
                                if (hseq[i] !== "-" && hseq[i] !== "-") {
                                    res.push(qseq[i]);
                                    res_mid.push(midline[i]);
                                }
                            }
                            qseq = res.join("");
                            midline = res_mid.join("");
                            // res = [];
                            // for (let i = 0; i < qseq.length; i++) {
                            //     if(qseq[i] !== "-" && hseq[i] !== "-"){
                            //         res.push(qseq[i])
                            //     }
                            // }
                            // qseq = res.join("");
                            align_seq = this.insert_str(
                                align_seq,
                                hit_from,
                                hit_to,
                                qseq
                            );
                            align_mid = this.insert_str(
                                align_mid,
                                hit_from,
                                hit_to,
                                midline
                            );
                        });
                    }
                });
                this.align_seq = align_seq;
                this.align_mid = align_mid;
            },
            insert_str(str, start, end, changeStr) {
                return (
                    str.substr(0, start - 1) +
                    changeStr +
                    str.substr(start - 1 + changeStr.length)
                );
            },
            get_reduced_seq(natural_seq) {
                let raac_scheme = this.$store.state.raac_scheme;
                let reduced_seq = "";
                let reduced_map = {};
                raac_scheme.forEach((item) => {
                    let replace_aa = item.substr(0, 1);
                    for (let i = 0; i < item.length; i++) {
                        reduced_map[item[i]] = replace_aa;
                    }
                });
                for (let i = 0; i < natural_seq.length; i++) {
                    reduced_seq += reduced_map[natural_seq[i]];
                }
                return reduced_seq;
            },

            seq_download(command) {
                // console.log(command);
                let from_svg = document.getElementById("sequence_viewer").outerHTML;

                this.img_type = "image/png";
                this.suffix = "";

                switch (command) {
                    case "png":
                        this.img_type = "image/png";
                        this.suffix = "png";
                        break;
                    case "jpg":
                        this.img_type = "image/jpeg";
                        this.suffix = "jpg";
                        break;
                    case "pdf":
                        this.img_type = "application/pdf";
                        this.suffix = "pdf";
                        break;
                    case "svg":
                        this.img_type = "image/svg+xml";
                        this.suffix = "svg";
                        break;
                    case "print":
                        this.img_type = "Print";
                        break;
                }

                if (command === "svg") {
                    const blob = new Blob([from_svg], {
                        type: "image/svg+xml"
                    });
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    a.setAttribute(
                        "download",
                        this.accession  + ".svg"
                    );
                    a.click();
                } else {
                    let url = `${this.website}/api/to_img/`;
                    fetch(url, {
                            method: "POST",
                            headers: {
                                "content-type": "application/json",
                            },
                            body: JSON.stringify({
                                svg_img: from_svg,
                                img_type: this.suffix,
                            }),
                        })
                        .then((res) => res.json())
                        .then((data) => {
                            var img_url = `data:${this.img_type};base64,${data.results.img}`;
                            const a = document.createElement("a");
                            a.href = img_url;
                            a.setAttribute(
                                "download",
                                this.accession +
                                "." +
                                this.suffix
                            );
                            a.click();
                        });
                }
                // const a = document.createElement('a')
                // const blob= new Blob([from_svg], {type: "PNG image"});
                // a.href = URL.createObjectURL(blob)
                // a.setAttribute('download', this.accession + "_" + this.$route.params.jobid + ".png")
                // a.click()
            },
            refresh() {
                this.loading = true;
                this.$store.commit("selectedRangeMutation", {
                    start: 0,
                    end: 0
                });
                let sequence_menu = this.$store.state.sequence_menu;
                delete sequence_menu["range"];
                sequence_menu["color"] = [""];
                sequence_menu["representation"] = [""];
                sequence_menu["focus"] = false;
                sequence_menu["multi"] = false;
                sequence_menu["is_show"] = false;
                sequence_menu["delete"] = [""];
                // delete sequence_menu["range"];
                this.$store.commit("sequenceMenuMutation", sequence_menu);
                this.main_process();
            },
            bmtooltips() {},
        },
    };
    buildSeq;

    function buildSeq(seqs, wrod_wrap) {
        if (wrod_wrap) {
            let seqs = wordWrap(seqs, wrod_wrap);
        }
        // let name_length = getMaxLength(seqs);
        // let seqs_count = Object.keys(seqs).length;
        // let l_padding = 5,
        //     // t_padding = 5,
        //     // b_padding = 5,
        //     // r_padding = 5,
        //     m_padding = 15,
        //     font_size = 18,
        // r_width = 18,
        // r_height = 22,
        // line_display = true,
        // char_length = name_length * (font_size / 2),
        // l_t_padding = l_padding + m_padding + char_length;
        // w = wrod_wrap * 18 + l_t_padding + r_padding,
        // h = t_padding + b_padding + seqs_count * 2 * r_height
        // if (!line_display) h = t_padding + b_padding + seqs_count * r_height
        // if (!wrod_wrap) w = seqs['Natural'].length * 18 + l_t_padding + r_padding
        var svg = d3
            .select("#seq_container")
            .append("svg")
            .attr("width", 500)
            .attr("height", 270)
            .attr("background", "red");
        svg;
        // console.log("build_seq", svg)
        for (var k in seqs) {
            // addname(svg, k, j, name_length, 1)
            for (var i = 0; i < seqs[k].length; i++) {
                // if (k == "Natural") {
                // } else {
                // }
                // addAA(svg, seqs[k][i], i, j, 1, give_color);
            }
            // j += 1;
        }
    }

    // function addname(svg, name, j, name_length, line) {
    //     var temp_length = name_length - name.length,
    //         text_x = l_padding + temp_length * (9)
    //     if(line) rect_y = (j) * r_height * 2 + t_padding
    //     else rect_y = (j) * r_height + t_padding
    //     var text_y = rect_y + r_height / 2
    //     if(!line_display) {
    //
    //     }
    //     name = name.replace(RegExp("_", "g"), " ")
    //     var text = svg.append('text')
    //         .text(name)
    //         .attr('fill', "#333333")
    //         .attr('x', text_x)
    //         .attr('y', text_y)
    //         .attr('dy', '6')
    // }
    // function addAA(svg, aa, i, j, line, give_color) {
    //     var colors = {
    //         "A": "#f3a683",
    //         "R": "#f7d794",
    //         "N": "#778beb",
    //         "D": "#e77f67",
    //         "C": "#cf6a87",
    //         "Q": "#f19066",
    //         "E": "#f5cd79",
    //         "G": "#546de5",
    //         "H": "#e15f41",
    //         "I": "#c44569",
    //         "L": "#786fa6",
    //         "K": "#f8a5c2",
    //         "M": "#63cdda",
    //         "F": "#ea8685",
    //         "P": "#596275",
    //         "S": "#574b90",
    //         "T": "#f78fb3",
    //         "W": "#3dc1d3",
    //         "Y": "#e66767",
    //         "V": "#303952"
    //     }
    //     var rect_x = l_t_padding + i * r_width
    //     if(line) rect_y = (j) * r_height * 2 + t_padding
    //     else rect_y = (j) * r_height + t_padding
    //     var text_x = l_t_padding + i * r_width + r_width / 2,
    //         text_y = rect_y + r_height / 2,
    //         bk_color = "#1e1e1e00",
    //         tx_color = "#1e1e1e"
    //
    //     if (give_color) {
    //         bk_color = colors[aa]
    //         tx_color = "white"
    //     }
    //
    //     if (give_color) {
    //         svg.append('rect')
    //             .attr('width', r_width)
    //             .attr('height', r_height)
    //             .attr('x', rect_x)
    //             .attr('y', rect_y)
    //             .attr('fill', bk_color)
    //     }
    //     var text = svg.append('text')
    //         .text(aa)
    //         .attr('fill', tx_color)
    //         .attr('x', text_x)
    //         .attr('y', text_y)
    //         .attr('text-anchor', 'middle')
    //         //						  	.attr("dominant-baseline","middle")
    //         // .style('font-size', font_size)
    //         // .attr("font-family", "Consolas, Helvetica, Arial, sans-serif")
    //         .attr('dy', '6')
    //     //								svg.append("rect")
    //     //									.attr("height","26")
    //     //									.attr("width","18")
    //     //									.attr("y",bk_y)
    //     //									.attr("x",bk_x)
    //     //									.attr("fill",color)
    //     //				svg.append("text")
    //     //					.attr("y",text_y)
    //     //					.attr("x",text_x)
    //     //					.attr("fill","#ffffff")
    //     //					.attr("font-size","18")
    //     //					.attr("text-anchor","middle")
    //     //					.text(aa)
    //     //					.attr("font-weight","bold")
    //     //					.attr("stroke-width","#07cdf5")
    //     //					.attr("stroke","#00000070")
    //     //					.attr("font-family","Consolas, Helvetica, Arial, sans-serif")
    //     //					.attr("dominant-baseline","middle");
    // }

    // function addLine(svg, i, j) {
    //     var colors = {
    //         "A": "#f3a683",
    //         "R": "#f7d794",
    //         "N": "#778beb",
    //         "D": "#e77f67",
    //         "C": "#cf6a87",
    //         "Q": "#f19066",
    //         "E": "#f5cd79",
    //         "G": "#546de5",
    //         "H": "#e15f41",
    //         "I": "#c44569",
    //         "L": "#786fa6",
    //         "K": "#f8a5c2",
    //         "M": "#f3a683",
    //         "F": "#ea8685",
    //         "P": "#596275",
    //         "S": "#574b90",
    //         "T": "#f78fb3",
    //         "W": "#3dc1d3",
    //         "Y": "#e66767",
    //         "V": "#303952"
    //     }
    //     var font_size = '18px'
    //     rect_x = l_t_padding + i * r_width,
    //         rect_y = r_height + (j * r_height) * 2 + t_padding,
    //         text_x = l_t_padding + i * r_width + r_width / 2,
    //         text_y = rect_y + r_height / 2
    //
    //     //				var g = svg.append('g')
    //     //				var rect = g.append('rect')
    //     //							.attr('width',width)
    //     //							.attr('height',height)
    //     //							.attr('x', rect_x)
    //     //						  	.attr('y', rect_y)
    //     //						  	.attr('fill',"white")
    //     var text = svg.append('text')
    //         .text("|")
    //         .attr('fill', "#333333")
    //         .attr('x', text_x)
    //         .attr('y', text_y)
    //         .attr('text-anchor', 'middle')
    //         //						  	.attr("dominant-baseline","middle")
    //         .attr('dy', '5')
    // }
    function wordWrap(seqs, wrap_col) {
        let length = seqs[get_dict_first_key(seqs)].length + wrap_col;
        let start = 0,
            end = start + wrap_col,
            res_json = {};
        while (end < length) {
            for (let k in seqs) {
                // let name 修改过
                let name = k + addNull(start) + start;
                res_json[name] = seqs[k].substring(start, end);
            }

            start = end;
            if (end > length) {
                end = length;
            } else {
                end = start + wrap_col;
            }
        }
        return res_json;
    }

    function addNull(num) {
        switch ((num + "").length) {
            case 1:
                return "___";
            case 2:
                return "__";
            case 3:
                return "_";

            default:
                break;
        }
    }

    function get_dict_first_key(dict) {
        for (let item in dict) {
            return item;
        }
    }

    getMaxLength;

    function getMaxLength(seqs) {
        let max = "";
        for (let k in seqs) {
            if (k.length > max.length) max = k;
        }
        return max.length;
    }
</script>

<style scoped>
    .bm-container {
        position: relative;
    }

    .bm-tooltip {
        font-family: sans-serif;
        boxshadow: rgb(0 0 0 / 20%) 1px 2px 10px;
        font-size: 16px;
        width: 120;
        borderradius: 4px;
        zindex: 10;
        height: auto;
        position: absolute;
        text-align: center;
        border-style: solid;
        border-width: 1px;
        background-color: white;
        border-radius: 5px;
        color: rgb(102, 102, 102);
        transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s,
            visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s,
            transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;
    }

    .download-dropdown .el-icon-arrow-down:before {
        content: "";
    }

    .download-dropdown [class*=" el-icon-"],
    [class^="el-icon-"] {
        /*line-height: 0;*/
    }

    .download-dropdown .el-dropdown {
        /* color: transparent; */
        padding: 0px;
        font-size: 28px;
        color: #332b1f;
    }

    .bm-none {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .baimo-scrollbar {
        /*position: relative;*/
        /*display: block;*/
        /*width: 0;*/
        /*height: 0;*/
        /*cursor: pointer;*/
        /*border-radius: inherit;*/
        /*background-color: rgba(144,147,153,.3);*/
        /*transition: .3s background-color;*/
        overflow: auto !important;
        overflow-x: auto;
        overflow-y: auto;
    }

    .baimo-scrollbar ::-webkit-scrollbar-track-piece {
        background-color: #f8f8f8;
        /*border: 1px solid red;*/
    }

    .baimo-scrollbar ::-webkit-scrollbar {
        width: 12px;
        height: 12px;
    }

    .baimo-scrollbar ::-webkit-scrollbar-thumb {
        /*background-image:url('https://static.runoob.com/images/mix/smiley.gif');*/
        /*box-shadow: 5px 5px 5px #888888 inset;*/
        background-color: rgba(144, 147, 153, 0.3);
        background-clip: padding-box;
        border-radius: 5px;
        transition: 0.3s background-color;
        min-height: 28px;
    }

    .baimo-scrollbar ::-webkit-scrollbar-thumb:hover {
        background-color: #bbb;
    }

    .topright-icon {
        float: right;
        left: 10px;
        top: 10px;
    }

    svg {
        background-color: blue;
    }

    .bm-btn {
        cursor: pointer;
    }

    .bm-toolbar-btn {
        font-size: 12px;
        margin-bottom: 15px;
        padding-bottom: 15px;
        padding-left: 10px;
        font-style: normal;
        cursor: pointer;
        /* box-shadow:0 1px 0 rgba(0,0,0,.2) inset,0 -1px 0 rgba(255,255,255,.2) inset; */
    }

    .el-dropdown-menu__item {
        list-style: none;
        line-height: 25px !important;
        padding: 0 20px !important;
        margin: 0;
        font-size: 14px !important;
        color: #606266;
        cursor: pointer;
        outline: 0;
    }
</style>